import { useTranslation } from '@common/hooks/translation';
import React from 'react';

export const IframePopup = ({ url, closePopup }) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-frame">
      <div className="popup-main-content">
        <iframe src={url} width="100%" height="100%" />
      </div>
      <button
        type="button"
        onClick={() => {
          closePopup();
        }}
        className="popup-cancel-button"
      >
        {t('Cancel')}
      </button>
    </div>
  );
};
